import _bindInstanceProperty from "@babel/runtime-corejs3/core-js/instance/bind";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { g } from "xojs/lib/runtime/getGlobal"; // eslint-disable-next-line func-style

function getPlacePredictions() {
  var _this = this;

  return new _Promise(function (resolve, reject) {
    var autocompleteService = new g.google.maps.places.AutocompleteService();
    autocompleteService.getPlacePredictions({
      input: _this.query,
      types: ['establishment'],
      sessionToken: _this.sessionToken
    }, function (predictions, status) {
      var _g$google$maps$places = g.google.maps.places.PlacesServiceStatus,
          OK = _g$google$maps$places.OK,
          ZERO_RESULTS = _g$google$maps$places.ZERO_RESULTS;

      if (status !== OK && status !== ZERO_RESULTS) {
        return reject(status);
      }

      return resolve(predictions);
    });
  }).then(function (suggestions) {
    _this.suggestions = suggestions || [];
  });
}

export default (function (_ref) {
  var _ref$query = _ref.query,
      query = _ref$query === void 0 ? '' : _ref$query,
      sessionToken = _ref.sessionToken;
  var context = {
    query: query,
    suggestions: [],
    sessionToken: sessionToken
  };
  return _Promise.resolve().then(_bindInstanceProperty(getPlacePredictions).call(getPlacePredictions, context)).then(function () {
    return context.suggestions;
  });
});